import { getUserResponseSchema, getUsersResponseSchema, getUserCountResponseSchema, sendInviteResponseSchema, inviteSchema, getInvitesResponseSchema, getInviteCountResponseSchema, submitFeedbackResponseSchema, } from '@consigli/types';
import { createTransformer, createParams, mapToSnakeCase, } from './shared/base-api';
export const userApiEndpoints = (builder, coreApiBaseUrl) => ({
    getMyUser: builder.query({
        query: () => `${coreApiBaseUrl}/accounts/me/`,
        transformResponse: createTransformer(getUserResponseSchema, 'GetMyUser'),
        providesTags: ['Users'],
    }),
    getUser: builder.query({
        query: ({ id }) => ({
            url: `${coreApiBaseUrl}/accounts/${id}/`,
            method: 'GET',
        }),
        transformResponse: createTransformer(getUserResponseSchema, 'getUser'),
    }),
    getUsers: builder.query({
        query: ({ page, pageSize, search, orgIds, projectIds }) => {
            const params = createParams({ page, pageSize, search, orgIds, projectIds });
            return {
                url: `${coreApiBaseUrl}/accounts/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['Users'],
        transformResponse: createTransformer(getUsersResponseSchema, 'getUsers'),
    }),
    getUserCount: builder.query({
        query: () => `${coreApiBaseUrl}/accounts/count/`,
        transformResponse: createTransformer(getUserCountResponseSchema, 'GetUserCount'),
    }),
    inviteUser: builder.mutation({
        query: ({ recipients, organization, language, projects }) => ({
            url: `${coreApiBaseUrl}/invites/`,
            method: 'POST',
            body: mapToSnakeCase({ recipients, projects, language, organization }),
        }),
        transformResponse: createTransformer(sendInviteResponseSchema, 'inviteUser'),
        invalidatesTags: ['Invites'],
    }),
    acceptInvite: builder.mutation({
        query: (inviteId) => ({
            url: `${coreApiBaseUrl}/invites/${inviteId}/accept/`,
            method: 'POST',
        }),
        invalidatesTags: ['Invites', 'Users', 'Projects'],
    }),
    getInvite: builder.query({
        query: (inviteId) => ({
            url: `${coreApiBaseUrl}/invites/${inviteId}/`,
            method: 'GET',
        }),
        providesTags: ['Invites'],
        transformResponse: createTransformer(inviteSchema, 'getInvite'),
    }),
    getInvites: builder.query({
        query: ({ page, pageSize, status, search, recipient, invitedByEmail }) => {
            const params = createParams({
                page,
                pageSize,
                status,
                search,
                recipient,
                invitedByEmail,
            });
            return {
                url: `${coreApiBaseUrl}/invites/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['Invites'],
        transformResponse: createTransformer(getInvitesResponseSchema, 'getInvites'),
    }),
    getInviteCount: builder.query({
        query: ({ invitedByEmail }) => {
            const params = createParams({ invitedByEmail });
            return {
                url: `${coreApiBaseUrl}/invites/count/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['Invites'],
        transformResponse: createTransformer(getInviteCountResponseSchema, 'getInviteCount'),
    }),
    submitFeedback: builder.mutation({
        query: ({ type, service, message }) => ({
            url: `${coreApiBaseUrl}/accounts/feedback/`,
            method: 'POST',
            body: { type, service, message },
        }),
        transformResponse: createTransformer(submitFeedbackResponseSchema, 'submitFeedback'),
    }),
    updateSolutionViewerAccess: builder.mutation({
        query: ({ userId, solutionViewerAccess }) => ({
            url: `${coreApiBaseUrl}/accounts/${userId}/solution-viewer-access/`,
            method: 'PATCH',
            body: mapToSnakeCase({ solutionViewerAccess }),
        }),
        invalidatesTags: ['Users'],
    }),
    updateSolutionViewerDatacenterAccess: builder.mutation({
        query: ({ userId, solutionViewerDatacenterAccess }) => ({
            url: `${coreApiBaseUrl}/accounts/${userId}/datacenter-access/`,
            method: 'PATCH',
            body: mapToSnakeCase({ solutionViewerDatacenterAccess }),
        }),
        invalidatesTags: ['Users'],
    }),
    updateSolutionViewerWaterTreatmentAccess: builder.mutation({
        query: ({ userId, solutionViewerWaterTreatmentAccess }) => ({
            url: `${coreApiBaseUrl}/accounts/${userId}/water-treatment-access/`,
            method: 'PATCH',
            body: mapToSnakeCase({ solutionViewerWaterTreatmentAccess }),
        }),
        invalidatesTags: ['Users'],
    }),
    updateDebugModeAccess: builder.mutation({
        query: ({ userId, debugModeAccess }) => ({
            url: `${coreApiBaseUrl}/accounts/${userId}/debug-mode-access/`,
            method: 'PATCH',
            body: mapToSnakeCase({ debugModeAccess }),
        }),
        invalidatesTags: ['Users'],
    }),
});
